import { Model } from '../../_kernel/architecture'
import { z } from 'zod'
import { Money } from '../../_kernel/Money'

export const TaxValidation = z.object({
  total: z.instanceof(Money),
  included: z.boolean(),
  name: z.string(),
  client: z.instanceof(Money).optional(),
  local: z.instanceof(Money).optional(),
})

export class Tax extends Model {
  static create(total: Money, included: boolean, name: string, client?: Money, local?: Money) {
    TaxValidation.parse({ total, included, name, client, local })
    return new Tax(total, included, name, client, local)
  }

  static fromJSON({ amount, currency, included, name, client, local }: ReturnType<Tax['toJSON']>) {
    return new Tax(
      Money.fromJSON({ amount, currency }),
      included,
      name,
      client ? Money.fromJSON({ amount: client.amount, currency: client.currency }) : undefined,
      local ? Money.fromJSON({ amount: local.amount, currency: local.currency }) : undefined
    )
  }

  constructor(
    private readonly _total: Money,
    private readonly _included: boolean,
    private readonly _name: string,
    private readonly _client?: Money,
    private readonly _local?: Money
  ) {
    super()
  }

  total() {
    return this._total
  }

  included() {
    return this._included
  }

  name() {
    return this._name
  }

  client() {
    return this._client
  }

  local() {
    return this._local
  }

  toJSON() {
    return {
      amount: this._total.amount,
      currency: this._total.currency,
      included: this._included,
      name: this._name,
      ...(this._client ? { client: this._client?.toJSON() } : {}),
      ...(this._local ? { local: this._local?.toJSON() } : {}),
    }
  }
}
